import { createContext } from '@chakra-ui/react-utils';
import { type SystemStyleObject } from '@chakra-ui/react-v2';

import type { SelectPart } from './types';

export type SelectStyles = Partial<Record<SelectPart, SystemStyleObject>>;

const [SelectStylesProvider, useSelectStyles] = createContext<SelectStyles>({
  name: 'SelectStylesContext',
  errorMessage:
    'useSelectStyles: `context` is undefined. Seems you used a Select sub-component that required a styles context outside of a Select component.',
});

export { SelectStylesProvider, useSelectStyles };
